import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3612e1f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-content" }
const _hoisted_2 = { class: "section" }
const _hoisted_3 = { class: "row mb-5 pb-5 justify-content-center" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "row p-0" }
const _hoisted_6 = { class: "col-12 p-0" }
const _hoisted_7 = { class: "card p-3 mb-4 bg-green-gradient border-radius-10 d-block" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-6" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Account Type")
  ]),
  /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-12 mt-2" }, " My Investment Management ")
], -1))
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Balance")
], -1))
const _hoisted_12 = { class: "font-white font-size-12 mt-2" }
const _hoisted_13 = { class: "row mt-3" }
const _hoisted_14 = { class: "col-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Name")
], -1))
const _hoisted_16 = { class: "font-white font-size-12 mt-2" }
const _hoisted_17 = {
  class: "col-6",
  style: {"overflow-y":"auto","max-height":"125px"}
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "row mt-3" }
const _hoisted_20 = { class: "col-6 ac-last-first-c" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Account Reference")
], -1))
const _hoisted_22 = { class: "font-white font-size-12 mt-2" }
const _hoisted_23 = { class: "col-6 ac-last-first-c" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "font-white font-size-14 mt-1" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Date Account Established ")
], -1))
const _hoisted_25 = { class: "font-white font-size-12 mt-2" }
const _hoisted_26 = { class: "col-md-8" }
const _hoisted_27 = { class: "p-0 bg-white border-radius-10" }
const _hoisted_28 = {
  class: "row m-0 bg-white border-bottom",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-md-8 d-flex py-4 justify-content-start" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "font-size-16 font-grey m-0" }, [
    /*#__PURE__*/_createElementVNode("b", null, "My Investment Details"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("p", {
      class: "font-size-12 font-gray2",
      id: "transSubTitle"
    })
  ])
], -1))
const _hoisted_30 = { class: "col-md-4 d-flex justify-content-start py-4" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "Select Myinvestment Account", -1))
const _hoisted_32 = ["selected", "data-id", "value"]
const _hoisted_33 = { class: "row px-3" }
const _hoisted_34 = {
  key: 5,
  class: "col-md-12 px-1 py-3 border-bottom"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center" }, " Please select myinvestment account to view records. ", -1))
const _hoisted_36 = [
  _hoisted_35
]
const _hoisted_37 = { class: "my-4 p-0 bg-white border-radius-10" }
const _hoisted_38 = {
  class: "row m-0",
  style: {"border-radius":"10px 10px 0px 0px"}
}
const _hoisted_39 = { class: "col-md-12 d-flex justify-content-start border-bottom align-items-center py-2" }
const _hoisted_40 = { class: "nav chart-nav justify-content-between" }
const _hoisted_41 = { class: "nav-item" }
const _hoisted_42 = { class: "nav-item" }
const _hoisted_43 = { class: "nav-item" }
const _hoisted_44 = { class: "nav-item" }
const _hoisted_45 = { class: "nav-item" }
const _hoisted_46 = {
  key: 0,
  class: "row"
}
const _hoisted_47 = {
  key: 0,
  class: "col-md-12 mt-4 pt-2 d-flex justify-content-start align-items-center chartDiv",
  id: "lastMonthDiv"
}
const _hoisted_48 = { class: "p-2 mx-auto line-chart" }
const _hoisted_49 = {
  id: "chart1",
  style: {"height":"250px"}
}
const _hoisted_50 = {
  key: 1,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "threeMonthDiv"
}
const _hoisted_51 = { class: "p-2 mx-auto line-chart" }
const _hoisted_52 = {
  id: "chart2",
  style: {"height":"250px"}
}
const _hoisted_53 = {
  key: 2,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "sixMonthDiv"
}
const _hoisted_54 = { class: "p-2 mx-auto line-chart" }
const _hoisted_55 = {
  id: "chart3",
  style: {"height":"250px"}
}
const _hoisted_56 = {
  key: 3,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "yearChartDiv"
}
const _hoisted_57 = { class: "p-2 mx-auto line-chart" }
const _hoisted_58 = {
  id: "chart4",
  style: {"height":"250px"}
}
const _hoisted_59 = {
  key: 4,
  class: "col-md-12 mt-4 pt-2 justify-content-start align-items-center chartDiv",
  id: "allTimeDiv"
}
const _hoisted_60 = { class: "p-2 mx-auto line-chart" }
const _hoisted_61 = {
  id: "chart5",
  style: {"height":"250px"}
}
const _hoisted_62 = {
  key: 1,
  class: "row"
}
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "col-md-12 font-grey text-center" }, " Loading...", -1))
const _hoisted_64 = [
  _hoisted_63
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_basic = _resolveComponent("basic")!
  const _component_right_side = _resolveComponent("right-side")!
  const _component_portfolio_card = _resolveComponent("portfolio-card")!
  const _component_iheader = _resolveComponent("iheader")!
  const _component_investment = _resolveComponent("investment")!
  const _component_interest = _resolveComponent("interest")!
  const _component_docs = _resolveComponent("docs")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_basic, { load_on: _ctx.load_on }, null, 8, ["load_on"]),
    _createVNode(_component_right_side, {
      user_info: _ctx.user_info,
      customer_accounts: _ctx.customer_accounts
    }, null, 8, ["user_info", "customer_accounts"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("h5", _hoisted_12, _toDisplayString(_ctx.default_currency) + " " + _toDisplayString(_ctx.default_currency_icon) + " " + _toDisplayString(_ctx.myinvestment.default_currency_balance.toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createElementVNode("h5", _hoisted_16, _toDisplayString(_ctx.myinvestment.userac_name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subac, (subac) => {
                        return (_openBlock(), _createElementBlock("h5", {
                          class: "font-white font-size-12 mt-2",
                          key: subac.subac_id
                        }, [
                          _createTextVNode(_toDisplayString(subac.subac_name), 1),
                          _hoisted_18,
                          _createTextVNode(" " + _toDisplayString(subac.currency_name) + " " + _toDisplayString(subac.currency_symbol) + _toDisplayString((subac.investment_valuation).toLocaleString(undefined,{minimumFractionDigits: 2,maximumFractionDigits: 2})), 1)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("h5", _hoisted_22, " #" + _toDisplayString(_ctx.myinvestment.userac_reference_code), 1)
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _hoisted_24,
                      _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.myinvestment.userac_establish_date), 1)
                    ])
                  ])
                ])
              ]),
              _createVNode(_component_portfolio_card, {
                default_currency_icon: _ctx.default_currency_icon,
                customer_accounts: _ctx.customer_accounts,
                total_active_default_balance: _ctx.total_active_default_balance
              }, null, 8, ["default_currency_icon", "customer_accounts", "total_active_default_balance"])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("select", {
                    class: "text-right w-100 trans-filter",
                    id: "selected_subac_id",
                    onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.change_myinv($event.target.value,'investment')))
                  }, [
                    _hoisted_31,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myinvestments, (myinv) => {
                      return (_openBlock(), _createElementBlock("option", {
                        selected: myinv.myinvestment_id == _ctx.active_myinv_id,
                        key: myinv.myinvestment_id,
                        "data-id": 'subTitle'+myinv.myinvestment_id,
                        value: myinv.myinvestment_id
                      }, _toDisplayString(myinv.myinv_name) + " (" + _toDisplayString(myinv.currency_name) + ") ", 9, _hoisted_32))
                    }), 128))
                  ], 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_component_iheader, {
                  onMyinv_change: _ctx.change_myinv,
                  myinv_id: _ctx.active_myinv_id,
                  active_tab: _ctx.active_tab
                }, null, 8, ["onMyinv_change", "myinv_id", "active_tab"]),
                (_ctx.active_tab=='investment')
                  ? (_openBlock(), _createBlock(_component_investment, {
                      key: 0,
                      myinv_id: _ctx.active_myinv_id
                    }, null, 8, ["myinv_id"]))
                  : _createCommentVNode("", true),
                (_ctx.active_tab=='interest_payments')
                  ? (_openBlock(), _createBlock(_component_interest, {
                      key: 1,
                      myinv_id: _ctx.active_myinv_id
                    }, null, 8, ["myinv_id"]))
                  : _createCommentVNode("", true),
                (_ctx.active_tab=='myinv_loan_note')
                  ? (_openBlock(), _createBlock(_component_docs, {
                      key: 2,
                      myinv_id: _ctx.active_myinv_id,
                      doc_type: _ctx.active_tab
                    }, null, 8, ["myinv_id", "doc_type"]))
                  : _createCommentVNode("", true),
                (_ctx.active_tab== 'myinv_register')
                  ? (_openBlock(), _createBlock(_component_docs, {
                      key: 3,
                      myinv_id: _ctx.active_myinv_id,
                      doc_type: _ctx.active_tab
                    }, null, 8, ["myinv_id", "doc_type"]))
                  : _createCommentVNode("", true),
                (_ctx.active_tab=='docs')
                  ? (_openBlock(), _createBlock(_component_docs, {
                      key: 4,
                      myinv_id: _ctx.active_myinv_id,
                      doc_type: _ctx.active_tab
                    }, null, 8, ["myinv_id", "doc_type"]))
                  : _createCommentVNode("", true),
                ((typeof _ctx.active_myinv_id=='undefined') || _ctx.active_myinv_id=='' || _ctx.active_myinv_id==null || _ctx.active_myinv_id=='null')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("ul", _hoisted_40, [
                    _createElementVNode("li", _hoisted_41, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (this.active_chart=1)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==1}, "font-grey lastMonth chartBtn"])
                        }, "Last Month", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_42, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (this.active_chart=2)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==2}, "font-grey threeMonth chartBtn"])
                        }, "3M", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_43, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (this.active_chart=3)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==3}, "font-grey sixMonth chartBtn"])
                        }, "6M", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_44, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (this.active_chart=4)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==4}, "font-grey yearChart chartBtn"])
                        }, "Year", 2)
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_45, [
                      _createElementVNode("a", {
                        class: "nav-link",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (this.active_chart=5)),
                        href: "#"
                      }, [
                        _createElementVNode("b", {
                          class: _normalizeClass([{active:_ctx.active_chart==5}, "font-grey allTime chartBtn"])
                        }, "All", 2)
                      ])
                    ])
                  ])
                ])
              ]),
              (_ctx.on_chart==1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    (_ctx.active_chart==1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions1,
                                series: _ctx.series1
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions2,
                                series: _ctx.series2
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==3)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                          _createElementVNode("div", _hoisted_54, [
                            _createElementVNode("div", _hoisted_55, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions3,
                                series: _ctx.series3
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==4)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions4,
                                series: _ctx.series4
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.active_chart==5)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _createElementVNode("div", _hoisted_61, [
                              _createVNode(_component_apexchart, {
                                type: "line",
                                height: "250",
                                options: _ctx.chartOptions5,
                                series: _ctx.series5
                              }, null, 8, ["options", "series"])
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.on_chart==0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_62, _hoisted_64))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}